var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var $ = jQuery;

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var Help = function ($element) {
  this.show = bind(this.show, this);
  this.hide = bind(this.hide, this);

  this.element = $element;
  this.element.on("mouseover", this.show);
  this.element.on("mouseout", this.hide);
};

/* --------------------------------------------
  Show help content
  @Params: none
  @Returns: none
*/
Help.prototype.show = function (e) {
  this.element.addClass("help--show");
};

/* --------------------------------------------
  Hide help content
  @Params: none
  @Returns: none
*/
Help.prototype.hide = function (e) {
  this.element.removeClass("help--show");
};

module.exports = Help;
